import settings from '@/settings'

let get = (data, headers) => {
    const keys = Object.keys(data)
    let url = `${settings.apetrusApi}/vouchers/admin/?`
    for (let i = 0; i < keys.length; i++) {
      url = data[keys[i]] !== null && data[keys[i]] !== undefined && data[keys[i]] !== '' ? `${url}${url[url.length - 1] !== '?' ? '&' : ''}${keys[i]}=${data[keys[i]]}` : `${url}`
    }
    return fetch(url, {
      method: 'GET',
      mode: 'cors',
      cache: 'default',
      headers: headers
    })
}

let cancelarVoucher = (headers, id) => {
  return fetch(`${settings.apetrusApi}/vouchers/desativar/${id}/`, {
    method: 'DELETE',
    mode: 'cors',
    cache: 'default',
    headers: headers
  })
}

export default {
    get,
    cancelarVoucher
}
